/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultPendingMessageResponse } from '../../models/api-response-paged-result-pending-message-response';
import { PagedRequestPendingMessageSearchFilter } from '../../models/paged-request-pending-message-search-filter';

export interface SearchPendingMessages$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestPendingMessageSearchFilter
}

export function searchPendingMessages(http: HttpClient, rootUrl: string, params: SearchPendingMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultPendingMessageResponse>> {
  const rb = new RequestBuilder(rootUrl, searchPendingMessages.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultPendingMessageResponse>;
    })
  );
}

searchPendingMessages.PATH = '/v1/api/pending-messages/search';
